import Immutable from 'immutable';

export default Immutable.fromJS({
  errors       : null,
  isActive     : false,
  isSuccessful : null,
  loaded       : { byQuestionId : {} },
});
